export default function Hero() {
  return (
    <section id="inicio" className="relative min-h-[100svh] w-full overflow-hidden bg-primary-950">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=cinematic%20wide%20aerial%20photograph%20of%20a%20large%20cargo%20container%20ship%20departing%20an%20international%20port%20at%20blue%20hour%2C%20deep%20navy%20ocean%20tones%2C%20atmospheric%20haze%2C%20dramatic%20soft%20light%2C%20premium%20editorial%20maritime%20photography%2C%20moody%20elegant%20composition%2C%20high%20detail&width=1920&height=1080&seq=ocean-hero-port&orientation=landscape"
          alt="Navio cargueiro de contêineres partindo de um porto internacional ao anoitecer"
          title="Importação e comércio internacional"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-primary-950/70 via-primary-950/45 to-primary-950/55" />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/82 via-primary-950/32 to-transparent" />
      </div>

      <div className="pointer-events-none absolute inset-0" aria-hidden="true">
        <div className="absolute left-0 right-0 top-[42%] h-px bg-gradient-to-r from-transparent via-accent-400/30 to-transparent" />
        <div className="absolute left-0 right-0 top-[58%] h-px bg-gradient-to-r from-transparent via-accent-400/15 to-transparent" />
        <div className="absolute right-[12%] top-0 hidden h-full w-px bg-gradient-to-b from-transparent via-accent-400/20 to-transparent lg:block" />
      </div>

      <div className="relative z-10 mx-auto flex min-h-[100svh] w-full max-w-[1440px] flex-col justify-center px-4 pb-24 pt-32 md:px-8 lg:px-12">
        <p className="ocean-label text-[10px] text-accent-300 md:text-[11px]">Ocean Companhia de Comércio</p>

        <h1 className="mt-6 max-w-4xl font-heading text-[2.6rem] font-medium leading-[1.03] text-background-50 sm:text-5xl md:text-6xl lg:text-7xl">
          Produtos globais.
          <br />
          Presença nacional.
        </h1>

        <p className="mt-7 max-w-2xl text-sm leading-relaxed text-background-100/80 md:text-lg">
          Importação e comercialização de produtos para empresas de diferentes segmentos em todo o Brasil.
        </p>

        <div className="mt-14">
          <a
            href="#ocean"
            className="group inline-flex cursor-pointer items-center gap-3 text-background-100/75 transition-colors duration-300 hover:text-accent-300"
          >
            <span className="ocean-label text-[10px] md:text-[11px]">Explore a Ocean</span>
            <span className="flex h-8 w-8 items-center justify-center rounded-full border border-accent-400/40 transition-colors duration-300 group-hover:border-accent-400">
              <i className="ri-arrow-down-line text-base"></i>
            </span>
          </a>
        </div>
      </div>
    </section>
  );
}